import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledDropdown,
    UncontrolledTooltip,
} from "reactstrap";

import Breadcrumbs from 'components/Common/BreadcrumbTitle';
import TableContainerV1 from "components/Common/TableContainerV1";
import ToastDialog from "components/Common/ToastDialog";
import { getCIUser, changeUserStatus } from "../../http/fundLync/entityAndAddress.helper";
import Switch from "react-switch";
import CommonDialog from "components/Common/CommonDialog";
import { decryptedValue } from "common/utility";

const Offsymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                marginRight:'10px'
            }}
        >
            {" "}
            Inactive
        </div>
    );
};

const OnSymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                marginLeft:'10px'
            }}
        >
            {" "}
            Active
        </div>
    );
};

const TableActionsComponentToggle = (props, handleChange) => {
    const [checked, setChecked] = useState(props.isActive);
    const newObj = {};
    for (const key in props) {
        if (props[key] !== null) {
            newObj[key] = props[key];
        }
    }
    useEffect(() => {
        setChecked(props.isActive)
    }, [props]);
    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2"
                    onColor="#21aa47"
                    width={80}
                    onChange={() => {
                        newObj.isActive = !props.isActive
                        props.isActive = !props.isActive
                        setChecked(newObj.isActive)
                        handleChange(newObj);
                    }}
                    checked={checked}
                    />
            </DropdownToggle>
        </UncontrolledDropdown>
    )
}

const TableActionsComponent = (props) => {
    const navigate = useNavigate();

    const navigateToEditUsers = (id) => {
        const encryptedId = btoa(id.toString());
        const user = decryptedValue(localStorage.getItem("user"));
        navigate(`/${user.roleName}/editCIUser?id=${encodeURIComponent(encryptedId)}`);
    };

    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                    onClick={() => {
                        navigateToEditUsers(props.id);
                    }}
                >
                    <i
                        className="mdi mdi-pencil font-size-16 text-success me-1"
                        id="edittooltip"
                    ></i>
                    Edit
                    <UncontrolledTooltip placement="top" target="edittooltip">
                        Edit
                    </UncontrolledTooltip>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}


const CIUserList = () => {
    document.title = "CI User List | Fundlync";

    const navigate = useNavigate();
    const [ownerID, setOwnerID] = useState(null)
    const [userList, setUserList] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
    });
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [sortingOptions, setSortingOptions] = useState({
        column: "id",
        isAsc: false,
        optionalColumn: ["Action"],
    });
    const [toastInfo, setToastInfo] = useState({
        message: "",
        showToast: false,
        role: "",
    });
    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });


    const columns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "First Name",
                accessor: "firstName",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "Last Name",
                accessor: "lastName",
                filterable: true,
                Cell: (cellProps) => {
                    return `${cellProps.value || ''}`;
                },
            },
            {
                Header: "Role",
                accessor: "roleRole.display_name",
                filterable: true,
                Cell: (cellProps) => {
                    return `${cellProps.value || ''}`;
                },
            },
            {
                Header: "Email",
                accessor: "email",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "Mobile",
                accessor: "mobileNo",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: 'User Status',
                accessor: 'isActive',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return TableActionsComponentToggle(rowData, handleChange);
                },
            },
            {
                Header: "Action",
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return TableActionsComponent(rowData);
                },
            },
        ],
        []
    );

    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
            changeUser(data)
        } else {
            setShowCommonDialog({ isShow: false })
        }
    }

    const handleChange = (data) => {
        let message = 'Are you sure you want to de-activate user?'
        if (data.isActive) {
            message = 'Are you sure you want to activate the user?'
        }
        setShowCommonDialog({ isShow: true, message, data })
    };

    const changeUser = (data) => {
        let payLoad = {
            userId: data.id,
            isActive: data.isActive
        }
        changeUserStatus(payLoad).then((res) => {
            if (res && res.status) {
                if (data?.isActive) {
                    setToastInfo({
                        message: 'User activated',
                        showToast: true,
                        role: "success",
                    });
                } else {
                    setToastInfo({
                        message: 'User de-activated',
                        showToast: true,
                        role: "success",
                    });
                }
            } else {
                setToastInfo({
                    message: 'Failed to change user status',
                    showToast: true,
                    role: "error",
                });
            }
        }).catch((err) => {
            setToastInfo({
                message: 'Failed to change user status',
                showToast: true,
                role: "error",
            });
        })
    };

    const getUsers = data => {
        getCIUser(data)
            .then(responseFromAPI => {
                if (responseFromAPI.status && responseFromAPI.code == 200) {
                    setUserList(responseFromAPI.data.data)
                    const { totalItems, totalPages, currentPage } = responseFromAPI.data
                    setPagination({
                        pageIndex: currentPage,
                        pageCount: totalPages,
                        totalRecords: totalItems,
                    })
                } else {
                    setUserList([])
                    setPagination({
                        pageIndex: 0,
                        pageCount: 0,
                        totalRecords: 0,
                    })
                }
            })
            .catch(error => { })
    }
    const handlePageChange = (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
        setPageSize(pageSize);
        getUsers({ page, limit: pageSize, searchKey, columnName, sortingOrder, entityId: ownerID })
    }

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
    };

    const handleSearchFilter = (value, pageSize) => {
        setSearchValue(value);
        handlePageChange(1, pageSize, value);
    };
    const handleClearSearch = () => {
        setSearchValue("");
        handlePageChange(1, pageSize, "");
    };

    useEffect(() => {
        getUsers({})
    }, []);

    const handleCustomerClicks = () => {
        const user = decryptedValue(localStorage.getItem("user"));
        navigate(`/${user.roleName}/addCIUser`);
    };

    const buttonSection = (
        <div className="text-sm-end">
            <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={handleCustomerClicks}
            >
                <i className="mdi mdi-plus me-1" />
                {'Add CI User'}
            </Button>
        </div>
    );

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="CI User List" />
                    <Row className="vertical-scroll">
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <TableContainerV1
                                        columns={columns}
                                        data={userList}
                                        pagination={pagination}
                                        handlePageChange={handlePageChange}
                                        handleSearchFilter={handleSearchFilter}
                                        customSection={buttonSection}
                                        sortOptions={sortingOptions}
                                        handleSortColumn={handleSortColumn}
                                        handleClearSearch={handleClearSearch}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
             {
                showCommonDialog &&
                <CommonDialog
                    isShow={showCommonDialog.isShow}
                    message={showCommonDialog.message} data={showCommonDialog.data}
                    postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogAction}
                />
            }
        </>
    );
};

export default CIUserList;
